const splitNameParts = name => (name || '').trim().split(/\s+/).filter(Boolean);

const getFirstName = entity => {
  const [firstName = ''] = splitNameParts(entity?.name);
  return entity?.first_name || firstName;
};

const getLastName = entity => {
  const composedLastName = [entity?.middle_name, entity?.last_name]
    .filter(Boolean)
    .join(' ')
    .trim();

  if (composedLastName) {
    return composedLastName;
  }

  return splitNameParts(entity?.name).slice(1).join(' ');
};

const buildCustomAttributeVariables = (prefix, customAttributes = {}) => {
  return Object.entries(customAttributes || {}).reduce((acc, [key, value]) => {
    acc[`${prefix}.custom_attribute.${key}`] = value;
    return acc;
  }, {});
};

// Variáveis que só o back sabe resolver (#1507): `{{timezone_greeting}}` depende
// da hora no fuso da CONTA no momento do envio — que, em mensagem agendada, nem
// é agora. O front as mapeia para o próprio literal: assim o
// `replaceVariablesInMessage` do `@chatwoot/utils` as preserva (sem isso ele
// devolve '' para chave ausente e apaga a variável ao inserir resposta pronta
// ou assinatura) e o `getUndefinedVariablesInMessage` não as acusa de
// indefinidas. Quem resolve é o `TimeGreetingDrop`, ao criar a mensagem.
export const SERVER_RESOLVED_VARIABLES = {
  timezone_greeting: '{{timezone_greeting}}',
};

export const buildMessageVariables = ({
  contact = {},
  agent = {},
  conversation = {},
  inbox = {},
} = {}) => {
  const safeContact = contact || {};
  const safeAgent = agent || {};
  const safeConversation = conversation || {};
  const safeInbox = inbox || {};

  return {
    'contact.id': safeContact.id || '',
    'contact.name': safeContact.name || '',
    'contact.first_name': getFirstName(safeContact),
    'contact.last_name': getLastName(safeContact),
    'contact.email': safeContact.email || '',
    'contact.phone': safeContact.phone_number || safeContact.phone || '',
    'agent.name': safeAgent.name || '',
    'agent.first_name': getFirstName(safeAgent),
    'agent.last_name': getLastName(safeAgent),
    'agent.email': safeAgent.email || '',
    'conversation.id': safeConversation.display_id || safeConversation.id || '',
    'inbox.name': safeInbox.name || '',
    ...SERVER_RESOLVED_VARIABLES,
    ...buildCustomAttributeVariables(
      'contact',
      safeContact.custom_attributes || {}
    ),
    ...buildCustomAttributeVariables(
      'conversation',
      safeConversation.custom_attributes || {}
    ),
  };
};
